import { IMasterclass } from '@/entities/masterclass/types';

export interface IReview {
  id: number;
  description: string;
  rate: number;
  createdAt: string;
  status: ReviewStatusEnum;
  rejectReason: string;
  deleteReason: string;
  /** Имя в публичном отзыве (задаёт автор) */
  authorName?: string | null;
  reviewerEmail?: string | null;
  user?: {
    id: number;
    username: string;
    image: string;
    email?: string | null;
  } | null;
  images: string[];
  masterclass: IMasterclass;
}

/* eslint-disable unused-imports/no-unused-vars -- ложное срабатывание: члены enum используются по всему проекту */
export const enum ReviewStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
}
/* eslint-enable unused-imports/no-unused-vars */
